import { useIntl } from 'react-intl';

export const sortArrayByLabel = (unsortedArray, placeholderValue, otherValue) => {
  if (!unsortedArray.every(i => i.label)) {
    return unsortedArray;
  }

  const placeholderOption = unsortedArray.find(i => i.value === placeholderValue);
  const otherOption = unsortedArray.find(i => i.value === otherValue);
  const arrayWithoutDefaultOrOther = unsortedArray.filter(i => i.value !== placeholderValue && i.value !== otherValue);
  const sorted = arrayWithoutDefaultOrOther.sort((a, b) => a.label.localeCompare(b.label));
  if (placeholderOption) {
    sorted.unshift(placeholderOption);
  }
  if (otherOption) {
    sorted.push(otherOption);
  }
  return sorted;
};

export default function GetDictionaryArray(key, intl) {
  const intlArray = intl ?? useIntl();
  const result = intlArray.messages[key];
  return Array.isArray(result) ? result : [];
}
